import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  CollapseExpandAllGroupsButtonsPropsState,
  collapseExpandAllGroupsButtonsPropsChange,
} from './actions';

const replaceState = (
  _: CollapseExpandAllGroupsButtonsPropsState,
  newState: CollapseExpandAllGroupsButtonsPropsState
) => newState;

const handleCollapseExpandAllGroups = reducer(
  collapseExpandAllGroupsButtonsPropsChange,
  replaceState
);

const initialState = {
  expandCollapseAllButtonConfig: [],
};

const collapseExpandAllGroupsButtonProps$ =
  reducedStream<CollapseExpandAllGroupsButtonsPropsState>(
    `simple-block-diagram-collapse-expand-all-props`,
    initialState,
    [handleCollapseExpandAllGroups]
  );

export { collapseExpandAllGroupsButtonProps$ };
